import { render, staticRenderFns } from "./CulturaValues.vue?vue&type=template&id=a7c87f7c&scoped=true"
import script from "./CulturaValues.vue?vue&type=script&lang=js"
export * from "./CulturaValues.vue?vue&type=script&lang=js"
import style0 from "./CulturaValues.vue?vue&type=style&index=0&id=a7c87f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c87f7c",
  null
  
)

export default component.exports